import { useEffect, useState } from 'react';
import { fetchHolidays } from '@indipia/shared-features';

/**
 * 조회조건 바 기간 선택(`DateRangePicker`)에 넘길 공휴일 셋.
 *
 * ui-core 는 네트워크를 모르므로(§15.14) 공휴일 조회는 화면 쪽 책임이다.
 * 작업요청 목록·현장보고 목록·공사현황 세 화면이 같은 자리에서 같은 값을 쓰므로 여기 한 벌만 둔다.
 *
 * 해 단위로 통째로 받아둔다 — 달을 넘길 때마다 재조회하면 이미 그린 달력이 늦게 물드는 게 보인다.
 * 실패하면 빈 셋이다(`fetchHolidays` 가 삼킨다) — 공휴일 색이 빠질 뿐 달력은 그대로 뜬다.
 */
export function useHolidays(year: number = new Date().getFullYear()): Set<string> {
  const [holidays, setHolidays] = useState<Set<string>>(new Set());

  useEffect(() => {
    let cancelled = false;
    // 앞뒤 해까지 — 12월에 열면 다음 달(1월)이 옆 칸에 같이 뜬다
    fetchHolidays(`${year - 1}-01-01`, `${year + 1}-12-31`).then((dates) => {
      if (!cancelled) setHolidays(new Set(dates));
    });
    return () => { cancelled = true; };
  }, [year]);

  return holidays;
}
